import { CustomerService } from 'src/app/angularJS/services/customer/customer.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { PaymentService } from 'src/app/angularJS/services/payments/payments.service';
import { ChargeAccountService } from 'src/app/angularJS/services/charge-account/charge-account.service';
import { ProductSearchService } from 'src/app/angularJS/services/product/product-search.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';

/**
   * A Controller using the {@link actora.services.customerService} to handle the retrieval and display of customer charge account controller record detail.
   */
export class CustomerChargeAccountController {

  public static $inject = [
    '$state',
    '$rootScope',
    'customerService',
    'customer',
    'UserMessages',
    '$translate',
    'paymentService',
    'chargeAccountService',
    'productSearchService',
    'QueryBuilder',
    'LinkBuilder'
  ];

  public chargeAccounts: Array<InterACT.Interfaces.ChargeAccounts.ChargeAccount>;
  public registeredCards: Array<InterACT.Interfaces.Cards.Card>;
  public products: Array<InterACT.Interfaces.ProductSearch.SearchResult>;
  public paymentTokens: Array<InterACT.Interfaces.Payments.PaymentToken>;
  public paymentToken: InterACT.Interfaces.Payments.PaymentToken;
  public steps: Array<InterACT.Interfaces.ISteps>;
  public card: InterACT.Interfaces.Cards.Card;
  public customerLink: InterACT.Interfaces.ChargeAccounts.CustomerLink;
  public accountNumberDetails: Array<InterACT.Interfaces.Payments.PaymentToken>;
  public chargeAccountDetails: InterACT.Interfaces.ICreateChargeAccount;
  public isValidForm: boolean;
  public isPaymentCardFound: boolean;
  public isTravelCardFormValid: boolean;
  public isProductFormValid: boolean;
  public isPaymentFormValid: boolean;
  public currentLocale: string;
  public errorMessage: string;
  public cardNotFound: string;
  public types: Array<string>;
  public travelCardNotFound: string;
  public travelCards: Array<InterACT.Interfaces.Cards.Card>;
  public stepForward: Function;
  public stepBackward: Function;
  private name: string;
  constructor(
    private $state: ng.ui.IStateService,
    private $rootScope,
    private customerService: CustomerService,
    private customer: InterACT.Interfaces.Customers.Customer,
    private UserMessages: UserMessagesService,
    private $translate: ng.translate.ITranslateService,
    private paymentService: PaymentService,
    private chargeAccountService: ChargeAccountService,
    private productSearchService: ProductSearchService,
    private queryBuilder: QueryBuilder,
    private linkBuilder: LinkBuilder
  ) {
    this.customer = angular.copy(customer);
    this.currentLocale = $translate.use();
    this.registeredCards = [];
    this.card = <any>{};
    this.customerLink = <any>{};
    this.chargeAccountDetails = {};
    this.paymentToken = <any>{};
    this.products = [];
    this.paymentTokens = [];
    this.accountNumberDetails = [];
    this.name = this.customer.title + ' ' + this.customer.forename + ' ' + this.customer.surname;
    this.isValidForm = false;
    this.isProductFormValid = false;
    this.isTravelCardFormValid = false;
    this.isPaymentCardFound = false;
    this.isPaymentFormValid = false;
    this.chargeAccountDetails.unsettledAmount = 0;
    this.travelCardNotFound = this.$translate.instant('CUSTOMER_DETAIL.NO_CARD_FOUND');
    this.activate();
  }

  /**
   * call payment token to get associated payment card details.
   */
  public getPaymentTokens() {
    this.$rootScope.showSpinner = true;
    this.accountNumberDetails = [];
    const param = 'customer.link=' + '/customers/' + this.customer.id;
    this.paymentService.getPaymentTokens(undefined, undefined, param).then((paymentTokens: Array<InterACT.Interfaces.Payments.PaymentToken>) => {
      this.paymentTokens = paymentTokens;
      this.$rootScope.showSpinner = false;
      if (this.paymentTokens.length === 0) {
        this.setNoPaymentCardFound();
      }
    });
  }

  /**
   * call charge account to validate selected type for a customer
   */
  public getChargeAccounts(paramType: string) {
    const param = 'customer.link=' + '/customers/' + this.customer.id;
    this.chargeAccountService.getChargeAccounts(undefined, undefined, param).then((chargeAccounts: Array<InterACT.Interfaces.ChargeAccounts.ChargeAccount>) => {
      this.chargeAccounts = chargeAccounts;
      if (!angular.isUndefined(this.chargeAccounts) && this.chargeAccounts.length > 0) {
        for (let i = 0; i < this.chargeAccounts.length; i++) {
          if (this.chargeAccounts[i].type.name === paramType) {
            this.errorMessage = this.$translate.instant('CUSTOMER_DETAIL.TYPE_ALREADY_REGISTERED');
            this.isValidForm = true;
            this.$rootScope.showSpinner = false;
            this.isProductFormValid = true;
            return;
          }
        }
        this.errorMessage = '';
        this.isValidForm = false;
        this.isProductFormValid = false;
      }
    });
  }

  /**
   * call charge account service to create a charge account for a customer.
   */
  public createChargeAccount() {
    this.chargeAccountService.createChargeAccount(this.setupChargeAccount())
      .then((value) => {
        this.UserMessages.showToast('TOAST_MESSAGE.CHARGE_ACCOUNT.SUCCESS');
        this.goToChargeAccount();
      },
        (error) => {
          this.UserMessages.showToast('TOAST_MESSAGE.CHARGE_ACCOUNT.ERROR');
          this.goToChargeAccount();
        }
      );
  }

  /**
   * Retrieves any records from the product-search service that contain tags with a CTA value present
   */
  public searchCTAProducts() {
    this.$rootScope.showSpinner = true;
    const param = this.queryBuilder.newParam().fieldIs('tags', 'CTA');
    this.productSearchService.getProducts(undefined, undefined, param.getParam()).then((productSearchResult) => {
      this.products = productSearchResult.searchResults;
      this.$rootScope.showSpinner = false;
    });
  }

  /**
   * Initialises the controller by setting up any required steps on the form in the UI
   * and retrieves card details to be used in the first step
  */
  private activate() {
    this.steps = this.setupSteps();
    this.getTravelCards();
  }

  /**
   * A method which is used to set steppers
   */
  private setupSteps() {
    return [
      { id: 1, desc: this.$translate.instant('CUSTOMER_DETAIL.CHARGE_ACCOUNT_STEP1'), title: this.$translate.instant('CUSTOMER_DETAIL.CHARGE_ACCOUNT_STEP1_TITLE') },
      { id: 2, desc: this.$translate.instant('CUSTOMER_DETAIL.CHARGE_ACCOUNT_STEP2'), title: this.$translate.instant('CUSTOMER_DETAIL.CHARGE_ACCOUNT_STEP2_TITLE') },
      { id: 3, desc: this.$translate.instant('CUSTOMER_DETAIL.CHARGE_ACCOUNT_STEP3'), title: this.$translate.instant('CUSTOMER_DETAIL.CHARGE_ACCOUNT_STEP3_TITLE') },
      { id: 4, desc: this.$translate.instant('CUSTOMER_DETAIL.CHARGE_ACCOUNT_STEP4'), title: this.$translate.instant('CUSTOMER_DETAIL.CHARGE_ACCOUNT_STEP4_TITLE') }
    ];
  }

  /**
   * If payment record not found the use dummy data for further properties.
   */
  private setNoPaymentCardFound() {
    this.cardNotFound = this.$translate.instant('CUSTOMER_DETAIL.NO_PAYMENT_CARD_REGISTERED');
    this.isPaymentCardFound = true;
    this.isPaymentFormValid = true;
  }

  /**
   * A method which is used to showDialog and go back to smart media
   */
  private showConfirmDialog = () => {
    return this.UserMessages.buildConfirmDialog(
      'CONFIRM_DIALOG.CUSTOMER.TITLE',
      'CONFIRM_DIALOG.CUSTOMER.MESSAGE',
      {},
      'CONFIRM_DIALOG.CUSTOMER.CONFIRM',
      'CONFIRM_DIALOG.CUSTOMER.NO')
      .then(() => {
        this.goToChargeAccount();
      });
  }

  /**
   * Go to landing page of charge account.
   */
  private goToChargeAccount() {
    this.chargeAccountDetails = {};
    this.$state.go('customer.chargeAccount.list');
  }

  /**
   * Retrieves travel cards linked to a given customer with an ISRN present
   */
  private getTravelCards() {
    const param = this.queryBuilder.newParam().customerLinkIs(this.customer.id).and().statusIs('ACTIVE').and().exists('cardNumber.ISRN').getParam();
    this.customerService.getCards(param).then((registeredCards: Array<InterACT.Interfaces.Cards.Card>) => {
      this.travelCards = registeredCards;
    });
  }

  /**
   * Set the selected data for creating charge account.
   */
  private setupChargeAccount() {
    let chargeAccount: InterACT.Interfaces.ChargeAccounts.ChargeAccount;
    chargeAccount = <any>{};
    chargeAccount.scheme = this.getChargeAccountScheme();
    chargeAccount.status = <any>'ACTIVE';
    chargeAccount.type = this.getChargeAccountType();
    chargeAccount.customer = this.getCustomerLink();
    chargeAccount.usageTokens = this.getUsageToken();
    chargeAccount.paymentToken = <any>this.getPaymentToken();
    chargeAccount.unsettledRefunds = this.chargeAccountDetails.unsettledAmount;
    return chargeAccount;
  }

  /**
   * Set the scheme for creating charge account.
   */
  private getChargeAccountScheme() {
    return {
      abbreviation: this.customer.scheme.abbreviation,
      link: this.customer.scheme.link
    };
  }

  /**
   * Set the account type for creating charge account.
   */
  private getChargeAccountType() {
    return {
      name: this.chargeAccountDetails.product.name,
      link: this.chargeAccountDetails.product.link
    };
  }

  /**
   * Set the customer link for creating charge account.
   */
  private getCustomerLink() {
    return {
      name: this.name,
      link: '/customers/' + this.customer.id
    };
  }

  /**
   * Set the payment token for creating charge account.
   */
  private getPaymentToken() {
    return [{
      name: this.name,
      status: <any>this.chargeAccountDetails.accountDetails.status,
      link: '/payment-tokens/' + this.chargeAccountDetails.accountDetails.id
    }];
  }

  /**
   * Set the Usage token for creating charge account.
   */
  private getUsageToken() {
    return [{
      fulfilmentRequestLink: '',
      link: '',
      tokenType: '',
      mediaLink: {
        reference: this.chargeAccountDetails.selectedTravelCard.cardNumber['SERIAL_NUMBER'],
        link: '/cards/' + this.chargeAccountDetails.selectedTravelCard.id
      }
    }];
  }
}